import "./App.css";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OneSignal from "react-onesignal";

import Signin from "src/Pages/Authentication/Signin";
import Signup from "src/Pages/Authentication/Signup";
import ForgotPassword from "src/Pages/Authentication/ForgotPassword";
import ResetPassword from "src/Pages/Authentication/ResetPassword";
// import Main from "./Pages/main";
import WO from "./Pages/WO/WO";
import PO from "./Pages/PO/PO";
import { useEffect, useRef } from "react";
import Customer from "./Pages/Customer/Customer";
import Calendar from "./Pages/Calendar";
import WODetail from "./Pages/WO/details/WoDetail";
import PODetail from "./Pages/PO/PoDetail";
import ServiceTicket from "./Pages/ServiceTicket/ServiceTicket";
import TicketLayout from "./Pages/ticket/TicketLayout";
import TicketDetail from "./Pages/ticket/TicketDetail";
import UserGuides from "./Pages/userguides/UserGuides";
import UserService from "./Services/API/user.service";
import Recommendations from "./Pages/Recommendations/Recommendations";
import TOS from "./Pages/TOS/tos";
import Privacy from "./Pages/TOS/privacy";
import SetPassword from "./Pages/Authentication/SetPassword/SetPassword";
import LayoutWithTopBar from "./Layout/layoutwithtopbar";
import Account from "./Pages/Setting/Account/Account";
import Team from "./Pages/Setting/Team/team";
import NotificationCenter from "./Pages/Setting/Notification/notificationcenter";
import Company from "./Pages/Setting/Company/company";
import Vendor from "./Pages/Setting/Vendor/vendor";
import ReportCenter from "./Pages/Setting/Report/reportcenter";
import SettingsLayout from "./Layout/settingslayout";
import Branch from "./Pages/Setting/Branch/branch";
import CustomerDetail from "./Pages/Customer/CustomerDetail";
import Materials from "./Pages/Setting/material/Materials";
import Services from "./Pages/Setting/services/Services";
import WoAttachments from "./Pages/WO/WoAttachments";
import { useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "src/Redux/store";
import FormBuilderComponent from "./Pages/WO/Components/forms/FormBuilderComponent";
import FormViewerComponent from "./Pages/WO/Components/forms/FormViewerComponent";
import TemplateList from "./Pages/forms/templates/TemplateList";
import AllForms from "./Pages/forms/allforms/AllForms";
import RequirePhoneModal from "./Components/Authentication/RequirePhoneModal";

function App() {
  const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);
  const woNumber = useSelector((state) => state.Header.woNumber);
  const poNumber = useSelector((state) => state.Header.poNumber);
  const PrivateRoute = ({ auth: isAuthenticated, children }) => {
    return isAuthenticated ? children : <Navigate to="/" />;
  };
  // function PrivateRoute({ auth: isAuthenticated, children }) {
  //   return isAuthenticated ? children : <Navigate to="/" />;
  // }

  // try {
  //   OneSignal.init({
  //     appId: "6421c1e6-f5ed-4b26-8df7-dca0d80bf80f",
  //   }).then(() => {
  // OneSignal.Debug.setLogLevel("warn");
  //     OneSignal.login("rodrigo");
  //     OneSignal.User.addAlias("myAlias", "1");
  //     console.log("subscription ID: ", OneSignal.User.PushSubscription.id);
  //   });
  // } catch (e) {
  //   console.log(e);
  // }

  // Tracks whether OneSignal.init() has finished. login()/logout() called
  // before init completes are silently dropped by the web SDK, so we must
  // wait for this before syncing the authenticated user.
  const oneSignalReadyRef = useRef(false);

  // Links the current browser's push subscription to the logged-in user's
  // email (external_id). The backend targets users by external_id, so without
  // this the subscription exists but no notification can ever reach the user.
  const syncOneSignalUser = async () => {
    if (!oneSignalReadyRef.current) return;
    try {
      if (isAuthenticated) {
        const user = UserService.getCurrentUser();
        if (user?.email) {
          await OneSignal.login(user.email);
          // Covers the "subscribed before login" case: a subscription may
          // already exist but be opted out / unattached for this user.
          if (OneSignal.User?.PushSubscription?.optedIn === false) {
            await OneSignal.User.PushSubscription.optIn();
          }
          console.log(
            "OneSignal linked: ",
            OneSignal.User.PushSubscription.id,
            user.email
          );
        }
      } else {
        await OneSignal.logout();
      }
    } catch (error) {
      console.log("OneSignal sync error: ", error);
    }
  };

  useEffect(() => {
    syncOneSignalUser();
  }, [isAuthenticated]);

  useEffect(() => {
    // console.log("Notification.permission: ", Notification.permission);
    // if (Notification.permission !== "granted") {
    //   Notification.requestPermission().then((permission) => {
    //     console.log("Permission: ", permission);
    //   });
    // }
    let detachListeners;
    const setupOneSignal = async () => {
      detachListeners = await runOneSignal();
      oneSignalReadyRef.current = true;
      // init() may finish after the auth effect already ran; sync now so a
      // user who was already authenticated on page load still gets linked.
      syncOneSignalUser();
    };
    setupOneSignal();
    return () => {
      if (typeof detachListeners === "function") {
        detachListeners();
      }
    };
  }, []);

  async function runOneSignal() {
    const appID =
      process.env.REACT_APP_ENV === "production"
        ? "7b554f0c-68e1-4701-97cb-9d46554611e7"
        : process.env.REACT_APP_ENV === "staging"
          ? "78cf09be-f363-4294-838d-695eb71bdee6"
          : "6421c1e6-f5ed-4b26-8df7-dca0d80bf80f";
    // OneSignal.Debug.setLogLevel("trace");
    await OneSignal.init({ appId: appID });
    OneSignal.User.PushSubscription.addEventListener("change", pushSubscriptionChangeListener);

    const handleForegroundWillDisplay = async (event) => {
      console.log("OneSignal: notification foregroundWillDisplay:", event);
    }
    const handleNotificationClick = async (event) => {
      console.log("OneSignal: notification click:", event);
      const additionalData = event?.notification?.additionalData;
      if (additionalData?.type === "TICKET_MESSAGE" && additionalData?.ticketId) {
        const targetPath = `/ticket/detail/${additionalData.ticketId}`;
        if (window.location.pathname !== targetPath) {
          window.location.assign(targetPath);
        }
      }
    };

    OneSignal.Notifications.addEventListener('foregroundWillDisplay', handleForegroundWillDisplay);
    OneSignal.Notifications.addEventListener('click', handleNotificationClick);

    return () => {
      OneSignal.User.PushSubscription.removeEventListener("change", pushSubscriptionChangeListener);
      OneSignal.Notifications.removeEventListener('foregroundWillDisplay', handleForegroundWillDisplay);
      OneSignal.Notifications.removeEventListener('click', handleNotificationClick);
    };
  }

  function pushSubscriptionChangeListener(event) {
    if (event.current.token) {
      console.log("The push subscription has received a token! ", OneSignal.User.PushSubscription.id);
      const user = UserService.getCurrentUser();
      // OneSignal.User.addAlias("Email", user.email);
      if (user) {
        OneSignal.login(user.email);
        console.log(
          "The push subscription has received a token! subscription_id: ",
          OneSignal.User.PushSubscription.id,
          user.email
        );
      }
    }
  }

  // const isSupported = OneSignal.Notifications.isPushSupported();
  // OneSignal.Slidedown.promptPush();
  // console.log("subscription ID: ", OneSignal.User.PushSubscription.id);
  // OneSignal.login("rodeli6607@armablog.com");

  // OneSignal.Notifications.addEventListener("click", (event) => {
  //   console.log("OneSignal: notification clicked:", event);
  // });

  // OneSignal.Notifications.addEventListener("foregroundWillDisplay", (event) => {
  //   console.log("OneSignal: notification foregroundWillDisplay:", event);
  // });

  // OneSignal.Slidedown.promptPush();

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastContainer />
        {isAuthenticated && <RequirePhoneModal />}
        <Routes>
          <Route path="/" element={<Signin />} />
          {/* <Route path="/signup" element={<Signup />} /> */}
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/resetpassword/:token" element={<ResetPassword />} />
          <Route path="/invite" element={<SetPassword />} />
          <Route
            path="/form-viewer/:formId"
            element={
              <FormViewerComponent />
            }
          />
          <Route element={<LayoutWithTopBar />}>
            <Route
              path="/work"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <WO />
                </PrivateRoute>
              }
            />
            <Route
              path="/work/:id"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <WODetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/work/:id/attachments"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <WoAttachments />
                </PrivateRoute>
              }
            />
            <Route
              path="/purchase"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <PO />
                </PrivateRoute>
              }
            />
            <Route
              path="/purchase/:id"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <PODetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/recommendations"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <Recommendations />
                </PrivateRoute>
              }
            />
            <Route
              path="/customer"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <Customer />
                </PrivateRoute>
              }
            />
            <Route
              path="/calendar"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <Calendar />
                </PrivateRoute>
              }
            />
            <Route
              path="/userguides"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <UserGuides />
                </PrivateRoute>
              }
            />
            <Route
              path="/ticket"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <TicketLayout />
                </PrivateRoute>
              }
            />
            <Route
              path="/ticket/new"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <TicketLayout />
                </PrivateRoute>
              }
            />
            <Route
              path="/ticket/detail/:ticketId"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <TicketDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/customer/:customerId"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <CustomerDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/serviceticket"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <ServiceTicket />
                </PrivateRoute>
              }
            />
            <Route
              path="/form-templates"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <TemplateList />
                </PrivateRoute>
              }
            />
            <Route
              path="/all-forms"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <AllForms />
                </PrivateRoute>
              }
            />
            <Route
              path="/form-builder"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <FormBuilderComponent />
                </PrivateRoute>
              }
            />
            <Route
              path="/form-builder/:woId"
              element={
                <PrivateRoute auth={isAuthenticated}>
                  <FormBuilderComponent />
                </PrivateRoute>
              }
            />

            <Route element={<SettingsLayout />}>
              <Route
                path="/settings/account"
                element={
                  <PrivateRoute auth={isAuthenticated}>
                    <Account />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings/team"
                element={
                  <PrivateRoute auth={isAuthenticated}>
                    <Team />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings/notification"
                element={
                  <PrivateRoute auth={isAuthenticated}>
                    <NotificationCenter />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings/company"
                element={
                  <PrivateRoute auth={isAuthenticated}>
                    <Company />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings/vendor"
                element={
                  <PrivateRoute auth={isAuthenticated}>
                    <Vendor />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings/report"
                element={
                  <PrivateRoute auth={isAuthenticated}>
                    <ReportCenter />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings/branch"
                element={
                  <PrivateRoute auth={isAuthenticated}>
                    <Branch />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings/materials"
                element={
                  <PrivateRoute auth={isAuthenticated}>
                    <Materials />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings/services"
                element={
                  <PrivateRoute auth={isAuthenticated}>
                    <Services />
                  </PrivateRoute>
                }
              />
            </Route>

          </Route>
          <Route path="/terms" element={<TOS />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </PersistGate>
    </Provider>
  );
}

export default App;
